import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'updateExtraCurrentEmailTemplate'

export default (data) => (asyncAction(
  name,
  ExtraCampaignsService.updateExtraCurrentEmailTemplate,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/updateExtraCurrentEmailTemplate.js